module.exports = __webpack_public_path__ + "static/industry-brief-building-materials-banner-4ae94e1f649e3e15248d145ace3db24f.png";